import { render } from "./VuexLicenceFormItem.vue?vue&type=template&id=67ae6d88"
import script from "./VuexLicenceFormItem.vue?vue&type=script&lang=js"
export * from "./VuexLicenceFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__